module.exports = [{
      plugin: require('/home/coder/project/clouden/clouden-ping/ui/node_modules/gatsby-plugin-layout/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/coder/project/clouden/clouden-ping/ui/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
